import { FacetBox } from './FacetBox';
import React, { useState, useRef, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import Badge from 'react-bootstrap/Badge';
import { HistoryBox } from './HistoryBox';
import { RecentSearch } from './RecentSearch';
import { useSearch } from '../hooks/useSearch';
import { openTabStore } from '../hooks/useCloseStore';
import {
    useQueryParams,
    StringParam,
    withDefault,
    encodeQueryParams,
} from 'use-query-params';
import { stringify } from 'query-string';
import { ArrayOfObjectsParam } from '../hooks/utils';
import MandalaSkeleton from '../views/common/MandalaSkeleton';
import { Redirect } from 'react-router';
// import { MdLogin } from 'react-icons/all';
import { useAdvancedSearch } from '../hooks/useAdvancedSearch';
import { at_regex, BasicSearch } from './BasicSearch';
import { SearchBar } from './SearchBar';
import $ from 'jquery';
import { SearchBoxAndButtons } from './SearchBoxAndButtons';

export const SEARCH_PATH = '/search/:view';
export const SEARCH_COOKIE_NAME = 'mandala_search';

export default function SearchAdvanced(props) {
    const history = useHistory();
    const location = useLocation();
    let [reset, setReset] = useState(0);
    let [filters, setFilters] = useState([]);
    const removedFacets = useAdvancedSearch((state) => state.removedFacets);
    const facetIsRemoved = useAdvancedSearch((state) => state.isRemoved);
    const facetRemoved = useAdvancedSearch((state) => state.facetRemoved);

    const isSearchPage = useRouteMatch('/search/:view');

    // Get function to handle closeButton state.
    //const handleCloseButton = closeStore((state) => state.changeButtonState);

    const openTab = openTabStore((state) => state.openTab);
    const setOpenTab = openTabStore((state) => state.changeButtonState);

    const handleCloseButton = (e) => {
        setOpenTab(0);
        $('.bottom-deck').hide();
    };

    // eslint-disable-next-line no-unused-vars
    const [query, setQuery] = useQueryParams({
        searchText: StringParam,
        filters: withDefault(ArrayOfObjectsParam, []),
    });

    // console.log("query in adv search", query);

    let { searchText: search, filters: qfilters } = query;

    if (
        JSON.stringify(filters) !== JSON.stringify(qfilters) &&
        qfilters?.length > 0
    ) {
        setFilters(qfilters);
    }

    // This tells us whether we are viewing the search results
    // so that we can give a link to go there (or not).
    const searchView = useRouteMatch(SEARCH_PATH);

    let [booleanControls, setBooleanControls] = useState(true);
    const {
        isLoading: isSearchLoading,
        data: searchData,
        isError: isSearchError,
        error: searchError,
    } = useSearch(search, 0, 0, 'all', 0, 0, true, filters);

    useEffect(() => {
        // Set Filters for asset type based on path on load if option is selection in wp site
        if (!filters || filters.length === 0) {
            if (window?.mandala_wp?.path_filter) {
                const path = window.location.pathname;
                const mtch = path.match(at_regex);
                if (mtch) {
                    const filter_asset = mtch[1]
                        .replace('thematic-', '')
                        .replace('modern-', '')
                        .replace('bibliographies', 'sources');
                    if (
                        !facetIsRemoved('asset_type', filter_asset) &&
                        filters.length === 0
                    ) {
                        let pageFilter = [
                            {
                                id: `asset_type:${filter_asset}`,
                                field: 'asset_type',
                                match: filter_asset,
                                label: filter_asset,
                                operator: 'AND',
                            },
                        ];
                        let encodedFilter = encodeQueryParams(
                            {
                                filters: withDefault(ArrayOfObjectsParam, []),
                            },
                            {
                                filters: pageFilter,
                            }
                        );

                        setFilters([
                            {
                                id: `asset_type:${filter_asset}`,
                                field: 'asset_type',
                                match: filter_asset,
                                label: filter_asset,
                                operator: 'AND',
                            },
                        ]);
                    }
                }
            }
        } else if (removedFacets?.length > 0) {
            const newFilters = filters.filter(
                (f) => !removedFacets.includes(f.id)
            );
            setFilters(newFilters);
        }
    }, [removedFacets, query]);

    let openclass = openTab > 0 ? 'open' : 'closed';

    //const historyStack = useStoreState((state) => state.history.historyStack);
    const historyStack = {};

    if (isSearchLoading) {
        return (
            <aside
                id="l-column__search"
                className={`l-column__search ${openclass}`}
            >
                <MandalaSkeleton
                    count={11}
                    height={25}
                    width={'100%'}
                    marginTop={'2rem'}
                />
            </aside>
        );
    }

    if (isSearchError) {
        return (
            <aside
                id="l-column__search"
                className={`l-column__search ${openclass}`}
            >
                <span>Error: {searchError.message}</span>
            </aside>
        );
    }

    // console.log('Search data', searchData);

    const handleBooleanControlClick = () =>
        setBooleanControls(!booleanControls);

    function gotoSearchPage(newFilters) {
        if (!searchView) {
            // Remove extra filter from adding filter based on WP page path
            if (filters?.length > 0 && newFilters?.length > 0) {
                if (
                    JSON.stringify(filters[0]) === JSON.stringify(newFilters[0])
                ) {
                    filters = [];
                }
            }
            //encode each parameter according to the configuration
            const encodedQuery = encodeQueryParams(
                {
                    searchText: StringParam,
                    filters: withDefault(ArrayOfObjectsParam, []),
                },
                {
                    searchText: search,
                    filters: [...filters, ...newFilters],
                }
            );

            if (process.env.REACT_APP_STANDALONE === 'standalone') {
                window.location.hash = `#/search/deck?${stringify(
                    encodedQuery
                )}`;
            } else {
                history.push({
                    pathname: `/search/deck`,
                    search: `?${stringify(encodedQuery)}`,
                });
            }
        } else {
            setQuery(
                {
                    searchText: search,
                    filters: [...newFilters],
                },
                'push'
            );
        }
    }

    function handleFacetChange(msg) {
        let newFilters = [...filters];
        const command = {
            facetType: msg.facetType,
            value: msg.value,
            operator: msg.operator,
            action: msg.action,
        };

        const compound_id = `${msg.facetType}:${msg.value}`;

        let changedFilters = [];

        if (command.action === 'add') {
            const new_filter = {
                id: compound_id,
                label: msg.labelText,
                operator: msg.operator,
                field: msg.facetType,
                match: msg.value,
            };
            let shouldAdd = true;
            const alteredFilters = newFilters.map((filter) => {
                if (filter.id === new_filter.id) {
                    shouldAdd = false;
                    return new_filter;
                }
                return filter;
            });
            if (shouldAdd) {
                changedFilters = [...alteredFilters, new_filter];
            }
        } else if (command.action === 'changeOperator') {
            changedFilters = newFilters.map((filter) => {
                if (filter.id === compound_id) {
                    return { ...filter, operator: msg.operator };
                }
                return filter;
            });
        } else if (command.action === 'remove') {
            facetRemoved(compound_id);
            const newFilterList = newFilters.filter(
                (filter) => !(filter.id === compound_id)
            );
            setFilters(newFilterList);
            changedFilters = newFilterList;
        }
        gotoSearchPage(changedFilters); // declaratively navigate to search
    }

    function handleNarrowFilters(narrowFilter) {
        const search = props?.search;
        if (search) {
            search.narrowFilters(narrowFilter);
        }
    }

    function getChosenFacets(type) {
        return filters.filter((filter) => filter.field === type);
    }

    if (searchView?.params?.view === ':view') {
        return <Redirect to={`/search/deck${location.search}`} />;
    }

    const showSearchBar =
        !process.env?.REACT_APP_SEARCHFORM_LOCATION ||
        process.env.REACT_APP_SEARCHFORM_LOCATION === 'sidebar';

    // TODO: review whether the FacetBoxes should be a configured list rather than hand-managed components as they are now.
    return (
        <aside
            id="l-column__search"
            className={`l-column__search ${openclass}`}
        >
            <div className="search-column-header-filters">
                <h4>
                    Total Results
                    <span className={'header-label-count'}>
                        <Badge pill variant={'secondary'}>
                            {searchData.response?.numFound}
                        </Badge>
                    </span>
                </h4>
                <button
                    onClick={handleCloseButton}
                    className={'search-column-close-filters'}
                >
                    <span className={'icon shanticon-cancel'}></span>
                </button>
            </div>

            <SearchBoxAndButtons
                eid="sui-search-filters"
                showSearchBar={showSearchBar}
                showClearAll={search || filters?.length > 0}
            />

            <p>Filters for refining search results.</p>
            <section>
                <FacetBox
                    id="asset_count"
                    label="resource type"
                    facets={searchData.facets?.asset_count?.numBuckets}
                    facetType={'asset_type'}
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('asset_type')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="collections"
                    label="collections"
                    facets={searchData.facets?.collections?.numBuckets}
                    facetType="collections"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('collections')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="related_subjects"
                    label="related subjects"
                    facets={searchData.facets?.related_subjects?.numBuckets}
                    facetType="subjects"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('subjects')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="related_places"
                    label="related places"
                    facets={searchData.facets?.related_places?.numBuckets}
                    facetType="places"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('places')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="related_terms"
                    label="related terms"
                    facets={searchData.facets?.related_terms?.numBuckets}
                    facetType="terms"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('terms')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="feature_types"
                    label="feature types"
                    facets={searchData.facets?.feature_types?.numBuckets}
                    facetType="feature_types"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('feature_types')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="languages"
                    label="languages"
                    facets={searchData.facets?.languages?.numBuckets}
                    facetType="languages"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('languages')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="node_user"
                    label="users"
                    facets={searchData.facets?.node_user?.numBuckets}
                    facetType="users"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('users')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="creator"
                    label="creator"
                    facets={searchData.facets?.creator?.numBuckets}
                    facetType="creator"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('creator')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="perspective"
                    label="perspective"
                    facets={searchData.facets?.perspective?.numBuckets}
                    facetType="perspective"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('perspective')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <FacetBox
                    id="associated_subjects"
                    label="Associated Subjects"
                    facets={searchData.facets?.associated_subjects?.numBuckets}
                    facetType="associated_subjects"
                    resetFlag={reset}
                    onFacetClick={handleFacetChange}
                    onNarrowFilters={handleNarrowFilters}
                    chosenFacets={getChosenFacets('associated_subjects')}
                    booleanControls={booleanControls}
                    search={search}
                    filters={filters}
                />
                <HistoryBox
                    historyStack={historyStack}
                    id="recent"
                    label="Recently Viewed"
                    facetType="recent-searches"
                />
                <RecentSearch
                    id="search"
                    label="Recent Searches"
                    facetType="recent-searches"
                />
            </section>
            <div className={'sui-advFooter'}>
                Show Boolean Controls? &nbsp;
                <input
                    type="checkbox"
                    onChange={handleBooleanControlClick}
                    checked={booleanControls}
                    id="sui-showBool"
                ></input>
            </div>
        </aside>
    );
}
